import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { StyledToggle } from "./toggle.scss";
import classnames from "classnames";
import { useState } from "react";
import { generateOnKeyDownHandler } from "/client/services/accessibility/accessibility-service";
const Toggle = (props)=>{
    const { handleToggle, toggleButtonColor, toggleBackgroundColor, leftPhrase, rightPhrase, swtichTextsColors } = props;
    const [isOn, setIsOn] = useState(false);
    const toggleSwitch = ()=>{
        setIsOn(!isOn);
        handleToggle();
    };
    const onKeyDown = generateOnKeyDownHandler(toggleSwitch);
    return /*#__PURE__*/ _jsxs(StyledToggle, {
        className: classnames("toggle", {
            on: isOn,
            "switch-texts-colors": swtichTextsColors
        }),
        onClick: toggleSwitch,
        style: {
            "--background-color": toggleBackgroundColor,
            "--switch-color": toggleButtonColor
        },
        role: "tablist",
        children: [
            /*#__PURE__*/ _jsx("div", {
                className: "toggle-left",
                role: "tab",
                tabIndex: 0,
                onKeyDown: onKeyDown,
                "aria-label": leftPhrase,
                children: leftPhrase
            }),
            /*#__PURE__*/ _jsx("div", {
                className: "toggle-right",
                role: "tab",
                tabIndex: 0,
                onKeyDown: onKeyDown,
                "aria-label": rightPhrase,
                children: rightPhrase
            })
        ]
    });
};
export default Toggle;
